import React from "react";
import PropTypes from "prop-types";
// import Img from "react-image";
import liteBGImg from "assets/Images/background.png";
import richBGImg from "assets/Images/background.png";
import "./DefaultBackground.scss";

const DefaultBackground = ({
  children = null,
  className,
  containerClass,
  containerStyle,
  contentClass,
  contentStyle,
  image: { src, loaderSrc, className: imgClassName, style: imgStyle } = {},
  overlay: { show: showOverlay, style: overlayStyle, className: overlayClass } = {}
}) => (
  <div className={`DefaultBackground ${className} ${containerClass}`} style={{ ...containerStyle }}>
    <div className="DefaultBackground__Image__Container">
      <img
        src={src || richBGImg}
        loader={
          <img
            className={`DefaultBackground__Image ${imgClassName}`}
            style={{ ...imgStyle }}
            src={loaderSrc || liteBGImg}
            alt=""
          />
        }
        alt=""
        className={`DefaultBackground__Image ${imgClassName}`}
        style={{ ...imgStyle }}
      />
    </div>
    {/* {showOverlay && (
      <div className={`DefaultBackground__Overlay ${overlayClass}`} style={{ ...overlayStyle }} />
    )} */}
    <div className={`DefaultBackground__Content ${contentClass}`} style={{ ...contentStyle }}>
      {children}
    </div>
  </div>
);

DefaultBackground.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  containerClass: PropTypes.string,
  containerStyle: PropTypes.object,
  contentClass: PropTypes.string,
  contentStyle: PropTypes.object,
  image: PropTypes.shape({
    src: PropTypes.any,
    loaderSrc: PropTypes.any,
    className: PropTypes.string,
    style: PropTypes.object
  }),
  overlay: PropTypes.shape({
    show: PropTypes.bool,
    style: PropTypes.object,
    className: PropTypes.string
  })
};
DefaultBackground.defaultProps = {
  containerStyle: {},
  containerClass: "",
  image: {
    className: "",
    style: {}
  },
  overlay: {
    show: true,
    style: {},
    className: ""
  }
};

export default DefaultBackground;
